import React from 'react';
import T from 'prop-types';
// components
import Button from '../../components/Button/Button';
import SupportInfoForm from './components/SupportInfoForm';
// styles
import styles from './UserProfileSupport.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const UserProfileSupport = ({
  user,
  updateUser,
  deleteAccount,
  changePassword,
}) => {
  const userColor = user.profile_color || '#33C370';

  return (
    <div className={cx('row', styles.container)}>
      <div>
        <h3>Personal Information</h3>
        <SupportInfoForm user={user} onSubmit={updateUser} color={userColor} />
        <br />

        <h3>Change Password</h3>
        <p className={styles.text}>
          You can change your password here. <br />
          Note: using stronger password gains more safety on your account.
        </p>
        <Button onClick={changePassword}>Change</Button>
        <br />
        <br />

        <h3>Delete Account</h3>
        <p className={styles.text}>
          You can end your subscription and delete your Ladder account any time.
          All your information will be permanently deleted.
        </p>
        <Button onClick={deleteAccount}>Delete</Button>
      </div>
    </div>
  );
};

UserProfileSupport.propTypes = {
  user: T.shape({
    username: T.string,
    email: T.string.isRequired,
  }),
  deleteAccount: T.func.isRequired,
  updateUser: T.func.isRequired,
};

export default UserProfileSupport;



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserProfileSupport.jsx